import * as S from './day-time-tab.wrapper.styles';

const DayTimeTabWrapper = ({ value, children }) => {
  if (!!value) return <S.TimeTabPanel value={value}>{children}</S.TimeTabPanel>;

  return children;
};

export default DayTimeTabWrapper;
